import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";
import { setupI18next } from "./i18n/i18n";
import { ErrorPage } from "./ErrorPage";
import { mfShorty } from "./constants";

const singleSpaLifecycle = singleSpaReact({
    React,
    ReactDOM,
    renderType: "render",
    rootComponent: Root,
    errorBoundary: (error, _, appProps) => <ErrorPage error={error} mfName={appProps.name} mfShorty={mfShorty} />,
});

export const bootstrap: typeof singleSpaLifecycle.bootstrap = (props) =>
    setupI18next().then(() => singleSpaLifecycle.bootstrap(props));

export const { mount, unmount } = singleSpaLifecycle;
